import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'app/users/shared/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilService } from 'app/hrms/shared/util.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { IOption } from 'ng-select';
import { Upload } from 'app/uploads/shared/upload';
import { UploadService } from 'app/uploads/shared/upload.service';
import { SessionService } from 'app/sessions/session.service';
import * as firebase from 'firebase/app';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { DateService } from 'app/date/date.service';

@Component({
  selector: 'app-view-employee-details',
  templateUrl: './view-employee-details.component.html',
  styleUrls: ['./view-employee-details.component.scss']
})
export class ViewEmployeeDetailsComponent implements OnInit {
  uid:any;
  user:any;
  myForm:FormGroup;
  fileList:any = [];
  branch:any;
  companyassets: Array<IOption> = [];
  driverDesignationKey:any;
  selectedFiles: FileList;
  selectedFileToUpload:FileList;
  currentUpload:Upload;
  public selectedImageToUpload = "assets/images/avatar-4.png";
  branchOptions:Array<IOption> = [];
  designationsOptions: Array<IOption> = [];
  departmentsOptions: Array<IOption> = [];
  reportingToOptions: Array<IOption> = [];
  companyassetsOptions: Array<IOption> = [];
  clickedOn:any;
  noFiles: string = 'No files uploaded.';
  public imageToUpload = "assets/images/avatar-4.png";
  isEdit:any = false;
  submitted:boolean = false;
  netSalary:number;
  maxLength:number = 9;
  employmentTypeOptions: Array<IOption> = [
    {label: 'Contract', value: 'Contract'},
    {label: 'Permanent', value: 'Permanent'}
  ];
  applicationRoleOptions: Array<IOption> = [
    {label: 'Super Admin', value: 'super admin'},
    {label: 'Admin', value: 'admin'},
    {label: 'Supervisor', value: 'supervisor'},
    {label: 'Employee', value: 'employee'},
    {label: 'Driver', value: 'driver'}
  ];
  @ViewChild("UploadModal") UploadModal;
  toDeleteUser:any;
  toDeleteUid:any;
  @ViewChild("deleteModal") deleteModal:any;
  constructor(private router:ActivatedRoute, private userService:UserService, private util:UtilService, private hrmsService:HRMSService, private ls:LogisticsService, private uploadService: UploadService, private ss:SessionService, private nf:NotificationToastService, private dateService: DateService, private routerNavigate:Router) { 
    this.router.params.subscribe((params) => {
      console.log("key",params['key']);
      this.uid  = params['key'];
    });
  }

  ngOnInit() {
    this.initializeForm();
    this.getCompanyAssets();
    this.getAllDesignations();
    this.getAllBranch();
    this.getAllDepartments();
    this.getReportingTo();
    setTimeout(() => {
      console.log("this.companyassets",this.companyassets);
      this.getUserDetails();
    }, 500);
  }
  public initializeForm()
  {
    this.myForm = new FormGroup({
      firstName: new FormControl('',Validators.required),
      middleName: new FormControl(''),
      lastName: new FormControl('',Validators.required),
      email: new FormControl('',[Validators.required,Validators.email]),
      dob: new FormControl('',Validators.required),
      /* userName: new FormControl('',Validators.required), */
      country: new FormControl('',Validators.required),
      phoneNumber: new FormControl('',Validators.required),
      address: new FormControl('',Validators.required),
      employeeId: new FormControl('',Validators.required),
      designation: new FormControl('',Validators.required),
      branch: new FormControl('',Validators.required),
      employmentType: new FormControl('',Validators.required),
      companyAssets: new FormControl(''),
      passportNumber: new FormControl(''),
      passportExpiryDate: new FormControl(''),
      joiningDate: new FormControl('',Validators.required),
      visaIssuedDate: new FormControl(''),
      visaExpiryDate: new FormControl(''),
      iqamaIssuedDate: new FormControl(''),
      iqamaExpiryDate: new FormControl(''),
      iqamaNumber: new FormControl('',Validators.required),
      department: new FormControl('',Validators.required),
      role: new FormControl('',Validators.required),
      reportingTo: new FormControl('',Validators.required),
      basic: new FormControl('',Validators.required),
      da: new FormControl(''),
      hra: new FormControl(''),
      conveyance: new FormControl(''),
      allowance: new FormControl(''),
      medicalAllowance: new FormControl(''),
      others: new FormControl(''),
      pf: new FormControl(''),
      tds: new FormControl(''),
      tax: new FormControl('')
    });
  }
  getUserDetails()
  {
    this.userService.getUser(this.uid).on("value",(data)=>{
      this.user = data.val();
        this.editDetails(data.val());
        this.viewDetails();
    });
  }
  get Currency()
  {
    var currency;
    this.hrmsService.getCurrency().on("value",(generalSetting)=>{
         currency =  generalSetting.child('currency').val();
      });
    return currency;
}
getCompanyAssets()
{
    this.hrmsService.getAllAssets().snapshotChanges().subscribe((data)=>{
    this.companyassets = [];
    this.companyassetsOptions = [];
    data.forEach(assest=>{
        this.companyassets[assest.key] = assest.payload.toJSON();
        this.companyassetsOptions.push({label: assest.payload.child("name").val(), value: assest.key});
    });
  });
}
viewDetails()
{
  console.log("user",this.user);
      this.ls.getBranchName(this.user.branch).once("value").then(branch=>{
        this.user.branch = branch.child("name").val();
      });
      this.hrmsService.getDepartmentName(this.user.department).once("value").then(department=>{
        this.user.department = department.child("name").val();
      });
      this.hrmsService.getDesignationName(this.user.designation).once("value").then(designation=>{
        this.user.designation = designation.child("name").val();
      });
      this.userService.getUser(this.user.reportingTo).once("value").then(reportingTo=>{
        this.user.reportingTo = reportingTo.child("firstName").val();
      });
      var assets =[];
        for(let asset in this.user.companyAssets)
        {
          assets.push(this.companyassets[this.user.companyAssets[asset]]);
        }
        this.user.assets = assets;
        console.log("assets",assets);
        this.calculateSalary(this.user);
}
editDetails(user)
{
  this.myForm.get('firstName').setValue(user.firstName);
  this.myForm.get('middleName').setValue(user.middleName?user.middleName:'');
  this.myForm.get('lastName').setValue(user.lastName);
  this.myForm.get('email').setValue(user.email);
  this.myForm.get('dob').setValue(user.dob);
  /* this.myForm.get('userName').setValue(user.userName); */
  this.myForm.get('country').setValue(user.country);
  this.myForm.get('phoneNumber').setValue(user.phoneNumber);
  this.myForm.get('address').setValue(user.address);
  this.myForm.get('employeeId').setValue(user.employeeId);
  this.myForm.get('designation').setValue(user.designation);
  this.myForm.get('branch').setValue(user.branch);
  this.myForm.get('employmentType').setValue(user.employmentType);
  this.myForm.get('companyAssets').setValue(user.companyAssets?user.companyAssets:'');
  this.myForm.get('passportNumber').setValue(user.passportNumber?user.passportNumber:'');
  this.myForm.get('passportExpiryDate').setValue(user.passportExpiryDate?user.passportExpiryDate:'');
  this.myForm.get('joiningDate').setValue(user.joiningDate?user.joiningDate:'');
  this.myForm.get('visaIssuedDate').setValue(user.visaIssuedDate?user.visaIssuedDate:'');
  this.myForm.get('visaExpiryDate').setValue(user.visaExpiryDate?user.visaExpiryDate:'');
  this.myForm.get('iqamaIssuedDate').setValue(user.iqamaIssuedDate?user.iqamaIssuedDate:'');
  this.myForm.get('iqamaExpiryDate').setValue(user.iqamaExpiryDate?user.iqamaExpiryDate:'');
  this.myForm.get('iqamaNumber').setValue(user.iqamaNumber?user.iqamaNumber:'');
  this.myForm.get('department').setValue(user.department);
  this.myForm.get('role').setValue(user.role);
  this.myForm.get('reportingTo').setValue(user.reportingTo);
  this.myForm.get('basic').setValue(user.basic);
  this.myForm.get('da').setValue(user.da?user.da:'');
  this.myForm.get('hra').setValue(user.hra?user.hra:'');
  this.myForm.get('conveyance').setValue(user.conveyance?user.conveyance:'');
  this.myForm.get('allowance').setValue(user.allowance?user.allowance:'');
  this.myForm.get('medicalAllowance').setValue(user.medicalAllowance?user.medicalAllowance:'');
  this.myForm.get('others').setValue(user.others?user.others:'');
  this.myForm.get('pf').setValue(user.pf?user.pf:'');
  this.myForm.get('tds').setValue(user.tds?user.tds:'');
  this.myForm.get('tax').setValue(user.tax?user.tax:'');
  this.calculateSalary(user);
}
toggleEditProfile()
{
  this.isEdit = !this.isEdit;
}
public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designationsOptions = [];
    item.forEach(element =>{
      if(element.payload.child("name").val() == 'Driver')
      {
        this.driverDesignationKey = element.key;
      }
        this.designationsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
public getAllDepartments()
{
  var x = this.hrmsService.getAllDepartments();
  x.snapshotChanges().subscribe(item=>{
  this.departmentsOptions = [];
  this.departmentsOptions.push({label: "All", value: "All"});
    item.forEach(element =>{
        this.departmentsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
getAllBranch()
{
  this.ls.getBranch().snapshotChanges().subscribe(data=>{
    this.branchOptions  = [];
    data.forEach(branch=>{
      this.branchOptions.push({
        label: branch.payload.child("name").val(),
        value: branch.payload.key
      })
    });
  });
}
getReportingTo()
{
  this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
    this.reportingToOptions = [];
    data.forEach(user=>{
      if(user.payload.child("role").val() == 'super admin' || user.payload.child("role").val() == 'admin' || user.payload.child("role").val() == 'manager')
      {
        console.log("user",user.payload.toJSON());
        this.reportingToOptions.push({label: user.payload.child("name").val(), value: user.key});
      }
    });
  });
}
public func(type)
  {
    switch(type)
        {
          case 'photo':
          this.imageToUpload = "assets/images/avatar-4.png";
          this.fileList[0]= null;
          break;
          case 'dlf':
          this.fileList[1]= null;
          break;
          case 'dlb':
          this.fileList[2]= null;
          break;
          case 'pf':
          this.fileList[3]= null;
          break;
          case 'pb':
          this.fileList[4]= null;
          break;
          case 'vc':
          this.fileList[5]= null;
          break;
          case 'iq':
          this.fileList[6]= null;
          break;
        }
  }
  public detectFiles(event,type) {
    this.selectedFiles = event.target.files;
    console.log("this.selectedFiles",this.selectedFiles);
    console.log("file name",event.target.files[0].name);
    var name = event.target.files[0].name;
    this.readUrl(event,type,name);
    }

    public readUrl(fileEvent:any,type:string,name:string) {
    if (fileEvent.target.files && fileEvent.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:any) => {
        this.clickedOn = type;
        this.UploadModal.show();
        this.selectedFileToUpload = fileEvent.target.files;
        this.selectedImageToUpload = event.target.result;
      } 
      reader.readAsDataURL(fileEvent.target.files[0]);
    }
  }
  upload()
  {
    let file = this.selectedFileToUpload.item(0);
    this.currentUpload = new Upload(file);
    this.uploadFile();
  }
  uploadFile()
  {
    var uploadTask=this.uploadService.uploadFile(this.currentUpload,this.uid,this.currentUpload.file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) =>  {
      this.currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
    },
    (error) => {
      this.nf.addToast({title:'Error', msg:'Error while uploading photo', timeout: 5000, theme:'material', position:'bottom-right', type:'error'});
    },
    () => {
      this.currentUpload.url = uploadTask.snapshot.downloadURL;
      this.currentUpload.name = this.currentUpload.file.name;
      this.updateUserData();
    });
  }
  updateUserData()
  {
    switch(this.clickedOn)
    {
      case 'photo':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'photoUrl').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'Profile Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'dlf':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'drivingLicenceFront').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'DL Front Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'dlb':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'drivingLicenceBack').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'DL Back Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'pf':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'passportFront').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'Passport Front Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'pb':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'passportBack').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'Passport Back Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'vc':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'visaCopy').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'Visa Copy Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
          case 'iq':
            this.userService.updatePhotoUrl(this.currentUpload.url,this.uid,'iqama').then(()=>{
            this.UploadModal.hide();
            this.currentUpload = null;
            this.selectedFiles = null;
            this.nf.addToast({title:'IQAMA Uploded', msg:'Profile photo successfully uploaded', timeout: 5000, theme:'material', position:'bottom-right', type:'sucess'});
          });
          break;
    }
  }
  onSubmit()
  {
    this.submitted = true;
    if(this.myForm.valid)
    {
      this.constructData();
    }
  }
  private constructData()
  {
    var date_time = this.dateService.getTimeandDate();
    console.log("documents uploaded",this.fileList);
    var data = this.myForm.value;
    this.calculateSalary(data);
    data.email = this.user.email;
    if(this.myForm.value.visaIssuedDate != '')
    {
      data.visaIssuedDate = this.dateService.getDate(this.myForm.value.visaIssuedDate);
    }
    if(this.myForm.value.visaExpiryDate  != '')
    {
      data.visaExpiryDate = this.dateService.getDate(this.myForm.value.visaExpiryDate);
    }
    if(this.myForm.value.iqamaIssuedDate != '')
    {
      data.iqamaIssuedDate = this.dateService.getDate(this.myForm.value.iqamaIssuedDate);
    }
    if(this.myForm.value.iqamaExpiryDate != '')
    {
      data.iqamaExpiryDate = this.dateService.getDate(this.myForm.value.iqamaExpiryDate);
    }
    if(this.myForm.value.passportExpiryDate != '')
    {
      data.passportExpiryDate = this.dateService.getDate(this.myForm.value.passportExpiryDate);
    }
    data.joiningDate = this.dateService.getDate(this.myForm.value.joiningDate);
    data.dob = this.dateService.getDate(this.myForm.value.dob);
    data.name = this.myForm.value.firstName;
    data.updatedAt = date_time.date,
    data.updatedTime = date_time.time
    data.salary = this.netSalary;
    data.boardingStatus = "onboard";
    console.log("data",data);
    this.saveUserDetails(data)
  }
  private saveUserDetails(data)
  {
      this.userService.updateUser(this.uid,data).then(()=>{
        this.submitted = false;
        this.myForm.reset();
        this.netSalary = 0;
        this.isEdit = false;
        this.nf.addToast({title:'Update Success', msg:'Employee successfully updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        this.getUserDetails();
      });
  }
  private calculateSalary(data)
  {
    /* this.netSalary = data.basic + data.da + data.hra + data.allowance + data.others + data.conveyance + data.medicalAllowance 
    - data.tds - data.pf - data.tax; */
    this.netSalary = data.basic + Number(data.da?data.da:0) + Number(data.hra?data.hra:0) 
    + Number(data.allowance?data.allowance:0) + Number(data.others?data.others:0)
    + Number(data.conveyance?data.conveyance:0) + Number(data.medicalAllowance?data.medicalAllowance:0)
    - Number(data.tds?data.tds:0) - Number(data.pf?data.pf:0) - Number(data.tax?data.tax:0);
    console.log("netSalary",this.netSalary);
  }
  keyPressCalculateSalary()
{
  this.calculateSalary(this.myForm.value);
}
public keyPress(event: any) {
  const pattern = /[0-9\+\-\ ]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (event.keyCode != 8 && !pattern.test(inputChar)) {
    event.preventDefault();
  }
  else
  {
    var phone = this.myForm.value.phoneNumber;
    if(phone.length >= this.maxLength)
    {
      event.preventDefault();
    }
  }
}

  private cancelBtn(){
    this.isEdit =false;
    this.myForm.reset();
    this.getUserDetails();
  }

  onDeleteEmployee()
    {
      this.toDeleteUid = this.uid;
      this.toDeleteUser = this.user.name;
      this.deleteModal.show();
    }
    deleteUser()
    {
      this.userService.deleteEmployee(this.toDeleteUid).then(()=>{
        //alert("deleted from db");
        this.userService.updateDeleteEmployeeToDeleteInAuth(this.toDeleteUid).then(()=>{
          //alert("deleted from auth");
          this.toDeleteUser = null;
          this.toDeleteUid = null;
          this.nf.addToast({title:'Success', msg:'Employee account has been deleted', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
          this.deleteModal.hide();
          this.routerNavigate.navigateByUrl('employees');
        });
      });
    }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/employee/view-employee-details/view-employee-details.component.ts